export const staffEn = {
  common: {
    actions: {
      cancel: 'Cancel',
      save: 'Save',
    },
    validation: {
      required: 'This field is required',
    },
  },
  job: {
    actions: {
      deleteJob: {
        description: 'Remove it from your system',
        title: 'Delete job',
      },
      locations: {
        description:
          'Select locations | {count} location selected | {count} locations selected',
        title: 'Locations access',
      },
      permissions: {
        description:
          'Select permissions | {count} permission selected | {count} permissions selected',
        title: 'Permissions',
      },
    },
    fields: {
      defaultHourlyPay: {
        label: 'Default hourly pay',
        placeholder: '0.00/hr',
      },
      title: {
        label: 'Title',
        placeholder: 'Job title',
      },
    },
    tooltips: {
      defaultHourlyPay:
        'Optional, add this if you want to use payroll reports.',
    },
    validation: {
      locations: 'At least one location must be selected',
      permissions: 'At least one permission must be selected',
    },
  },
  staffMember: {
    actions: {
      addJob: 'Add job',
      deleteUser: {
        description: 'Remove them from your company',
        title: 'Delete user',
      },
      jobs: {
        hourlyRateOverride: 'Hourly rate override',
        title: 'Jobs',
      },
      locations: {
        all: 'All locations',
        description: 'Select locations | {count} location | {count} locations',
        title: 'Locations access',
      },
      passcode: {
        description: 'View and reset passcode',
        title: 'Passcode',
      },
    },
    fields: {
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      phoneNumber: 'Phone number',
    },
    validation: {
      jobs: 'At least one job must be assigned',
    },
  },
}
